import { render, staticRenderFns } from "./NreBarcode.vue?vue&type=template&id=6b1bb187&scoped=true&"
import script from "./NreBarcode.vue?vue&type=script&lang=js&"
export * from "./NreBarcode.vue?vue&type=script&lang=js&"
import style0 from "./NreBarcode.vue?vue&type=style&index=0&id=6b1bb187&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1bb187",
  null
  
)

export default component.exports